import { PICTREE } from "../../constants";

const initialState = {
  loading: false,
  selectedSeasonId: "cmunxinty000079zc6zf595vs",
  selectedSeasonIds: ["cmunxinty000079zc6zf595vs"],
  selectedCompanyCode: "NTT_ME",
  seasonOptions: [
    // { value: "regular-season-4", label: "レギュラーシーズン4" },
    { value: "cmunxinty000079zc6zf595vs", label: "レギュラーシーズン3" },
    { value: "cmrz0wo8t0000bpzcana86bow", label: "レギュラーシーズン2" },
    { value: "cmp4yz2lj00017rtcc4ok0jgv", label: "レギュラーシーズン1" },
  ],
  companyOptions: [
    { value: "NTT_ME", label: "NTT ME", active: true },
    { value: "TEPCO", label: "東京電力 TEPCO", active: false },
    { value: "NTT_FT", label: "NTT FT", active: false },
  ],
  kpis: [
    {
      key: "uniqueShot",
      title: "ユニーク撮影本数",
      value: "--",
      // subtitle: "RS1〜5通算",
    },
    {
      key: "achievementRate",
      title: "撮影達成率",
      value: "--",
      subtitle: "対象 --本",
      // highlight: "NTT-ME 初期想定",
    },
    {
      key: "reviewOk",
      title: "レビューOK基数",
      value: "--",
      subtitle: "OK率 --%",
    },
    {
      key: "uniqueShooter",
      title: "ユニーク撮影者数",
      value: "--",
      subtitle: "累計参加者",
    },
    {
      key: "firstShooter",
      title: "初回撮影者数",
      value: "--",
      subtitle: "今期新規",
    },
  ],
  trend: {
    date: [],
    uniqueShots: [],
    reviewerOk: [],
    uniqueShooters: [],
  },
  trendLoading: true,
  companyRowsLoading: true,
  // seasonChart: {
  //   labels: ["RS1", "RS2", "RS3", "RS4", "RS5"],
  //   series: [
  //     { name: "NTT ME", data: [420, 385, 445, 374, 410] },
  //     { name: "TEPCO", data: [120, 98, 112, 94, 117] },
  //     { name: "NTT FT", data: [84, 79, 88, 72, 83] },
  //     { name: "その他", data: [22, 18, 24, 19, 21] },
  //   ],
  // },
  seasonChartLoading: true,
  seasonChart: {
    labels: [],
    series: [],
  },
  companyRows: [],
};

export default function pictreeRegularSeasonReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_REGULAR_SEASON_PAGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case PICTREE.SET_REGULAR_SEASON_PAGE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
